const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var FlagSl16 = function FlagSl16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
      fill: "#D8DDE1",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.5 5.93h15V4.012c0-.835-.671-1.512-1.5-1.512H2c-.828 0-1.5.678-1.5 1.512V5.93z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.5 9.436h15V5.904H.5v3.532z",
      fill: "#015DA4",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.5 11.3c0 .835.671 1.512 1.5 1.512h12c.829 0 1.5-.677 1.5-1.512V9.382H.5V11.3z",
      fill: "#CD1D28",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M3.129 6.567 3 6.208l-.05-.358h.95V7.2l-.4-.224-.371-.41z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "m4.671 6.567.129-.359.05-.358H3.9V7.2l.4-.224.371-.41z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "m3.4 4.65.5-.05.5.05v.45l-.5.2-.5-.2v-.45z",
      fill: "#FFE600",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.321 6.907c.16.16.357.28.573.345a1.38 1.38 0 0 0 .971-1.233l.007-.115.07-1.108a2.028 2.028 0 0 0-.074-.034l-.071 1.142-.008.11a1.304 1.304 0 0 1-.895 1.158A1.304 1.304 0 0 1 3 6.015l-.078-1.253-.074.034.07 1.108.007.116c.02.335.162.65.397.887",
      fill: "#FF1F1F",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m3.659 5.88.235-.475.236.475.157-.212.393.528a.266.266 0 0 1-.162.244.26.26 0 0 1-.23-.015.265.265 0 0 0-.263 0 .259.259 0 0 1-.262 0 .26.26 0 0 0-.261 0 .26.26 0 0 1-.373-.128.265.265 0 0 1-.02-.1l.393-.529.157.212zm-.142-1.168.073.008.03-.068.03.068.071-.008-.043.06.043.059-.072-.008-.03.067-.03-.067-.072.008.044-.06-.044-.06zm.275.37.073.007.03-.067.029.067.073-.008-.044.06.044.059-.073-.008-.03.068-.029-.068-.073.008.043-.06-.043-.059zm.275-.37.073.008.03-.068.029.068.072-.008-.043.06.043.059-.072-.008-.03.067-.03-.067-.072.008.043-.06-.043-.06zm.46 1.876a.26.26 0 0 1-.24-.01.261.261 0 0 0-.262 0 .26.26 0 0 1-.262 0 .26.26 0 0 0-.261 0s0-.001 0 0a.261.261 0 0 1-.24.01 1.28 1.28 0 0 1-.06-.105.288.288 0 0 1 .038.018.259.259 0 0 0 .262 0 .26.26 0 0 1 .261 0 .26.26 0 0 0 .262 0 .262.262 0 0 1 .262 0 .26.26 0 0 0 .262 0 .303.303 0 0 1 .038-.018 1.213 1.213 0 0 1-.06.105zm-.166.21a1.205 1.205 0 0 1-.467.293 1.215 1.215 0 0 1-.565-.406.256.256 0 0 0 .173-.032.26.26 0 0 1 .261 0 .26.26 0 0 0 .262 0 .262.262 0 0 1 .262 0 .255.255 0 0 0 .173.032c-.031.04-.064.078-.1.113zm-1.362-.784a1.304 1.304 0 0 0 .895 1.157 1.29 1.29 0 0 0 .625-.439c.16-.207.254-.457.27-.718l.008-.111.071-1.141a2.394 2.394 0 0 0-1.947 0l.078 1.252z",
      fill: "#005EA5",
    })
  );
};
FlagSl16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  16: FlagSl16,
};
export function FlagSl(_ref) {
  let { size = "16" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["16"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'FlagSl' icon. Please use one of the available sizes: '16'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
